import { createSlice } from '@reduxjs/toolkit'

const initialState = "fi_FI"

export const languageSlice = createSlice({
    name: "language",
    initialState,
    reducers: {
        changeLanguage: (state, action) => {
            return action.payload
        }
    }
})

export const { changeLanguage } = languageSlice.actions;

export default languageSlice


// WEBPACK FOOTER //
// ./src/state/slices/languageSlice.js